const components = [
  {
    name: "TopNav",
    doc: require("modules/avl-components/src/components/Nav/Top.docs.js")
      .default,
    img: "/images/components/topnav.png",
    section: "Navigation",
  },
  {
    name: "SideNav",
    doc: require("modules/avl-components/src/components/Nav/Side.docs.js")
      .default,
    img: "/images/components/sidenav.png",
    section: "Navigation",
  },
  {
    name: "Select",
    doc: require("modules/avl-components/src/components/Inputs/Select.docs.js")
      .default,
    img: "/images/components/select-menus.png",
    section: "Inputs",
  },
  {
    name: "Button",
    doc: require("modules/avl-components/src/components/Button/button.docs.js")
      .default,
    img: "/images/components/buttons.png",
    section: "Elements",
  },
  {
    name: "Input",
    doc: require("modules/avl-components/src/components/Inputs/input.docs.js")
      .default,
    img: "/images/components/input.png",
    section: "Inputs",
  },
  {
    name: "Table",
    doc: require("modules/avl-components/src/components/Table/Table.docs.js")
      .default,
    img: "/images/components/tables.png",
    section: "Elements",
  },
  {
    name: "TabPanel",
    doc: require("modules/avl-components/src/components/TabPanel/TabPanel.docs.js")
      .default,
    img: "/images/components/tabs.png",
    section: "Elements",
  },
];

export default components;
